import { render, staticRenderFns } from "./move_list_button.vue?vue&type=template&id=3c06aba6&"
import script from "./move_list_button.vue?vue&type=script&lang=js&"
export * from "./move_list_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports